module.exports = __webpack_public_path__ + "static/img/choose-cosmetician-01.d28a7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/choose-cosmetician-01.jpg
// module id = 251
// module chunks = 1